import { render, staticRenderFns } from "./DataError.vue?vue&type=template&id=fe5a33ec&"
import script from "./DataError.vue?vue&type=script&lang=ts&"
export * from "./DataError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports